module.exports = __webpack_public_path__ + "static/media/logo.f43a3112.svg";